import { db } from './firebase'
import { firestore } from 'firebase'
import { storage } from './firebase'
// User API
export const doCreateUser = (id: string, username: string, email: string) =>
  db.ref(`users/${id}`).set({
    email,
    username
  })

export const storageRef = () => storage.ref()

export const onceGetUsers = () => db.ref('users').once('value')

export const onceGetProjects = () => db.ref('projects').once('value')

export const onceUsers = () =>
  firestore()
    .collection('users')
    .where('companyid', '==', 1)

// Blogs
export const onceBlogs = (doc: any, limit: any) =>
  firestore()
    .collection('blogs')
    .where('publicAvailable', '==', 1)
    .orderBy('posted', 'desc')
    .startAt(doc)
    .limit(limit)

export const initBlogs = (limit: any) =>
  firestore()
    .collection('blogs')
    .where('publicAvailable', '==', 1)
    .orderBy('posted', 'desc')
    .limit(limit)

export const GetBlogDoc = (key: string) =>
  firestore()
    .collection('blogs')
    .doc(key)

export const FindBlog = (id: number) =>
  firestore()
    .collection('blogs')
    .where('id', '==', id)

export const FindBlogByName = (name: string) =>
  firestore()
    .collection('blogs')
    .where('url_name', '==', name)

export const FindNextBlog = (doc: any) =>
  firestore()
    .collection('blogs')
    .where('publicAvailable', '==', 1)
    .orderBy('posted', 'asc')
    .startAfter(doc)
    .limit(1)

export const FindPreviousBlog = (doc: any) =>
  firestore()
    .collection('blogs')
    .where('publicAvailable', '==', 1)
    .orderBy('posted', 'desc')
    .startAfter(doc)
    .limit(1)
// Images
export const onceImages = () => firestore().collection('images')
export const FindImage = (id: number) =>
  firestore()
    .collection('images')
    .where('id', '==', id)

export const FindImageGallery = (id: number) =>
  firestore()
    .collection('images')
    .where('galleryid', '==', id)

export const GetImageDoc = (key: string) =>
  firestore()
    .collection('images')
    .doc(key)
// Gallery
export const onceGalleries = () => firestore().collection('galleries')

// Events
export const onceEvents = () =>
  firestore()
    .collection('events')
    .where('publicAvailable', '==', 1)

export const GetEvent = (id: number) =>
  firestore()
    .collection('events')
    .where('id', '==', id)

export const GetEventDoc = (key: string) =>
  firestore()
    .collection('events')
    .doc(key)

// Projects & Experiments
export const GetProject = (id: number) =>
  firestore()
    .collection('projects')
    .where('id', '==', id)

export const FindEventByName = (name: string) =>
  firestore()
    .collection('events')
    .where('url_name', '==', name)

export const FindNextEvent = (doc: any) =>
  firestore()
    .collection('events')
    .where('publicAvailable', '==', 1)
    .orderBy('startDate', 'asc')
    .startAfter(doc)
    .limit(1)

export const FindPreviousEvent = (doc: any) =>
  firestore()
    .collection('events')
    .where('publicAvailable', '==', 1)
    .orderBy('startDate', 'desc')
    .startAfter(doc)
    .limit(1)

export const GetEventByName = (name: string) =>
  firestore()
    .collection('events')
    .where('url_name', '==', name)

export const GetProjectByName = (name: string) =>
  firestore()
    .collection('projects')
    .where('url_name', '==', name)

export const GetProjectDoc = (key: string) =>
  firestore()
    .collection('projects')
    .doc(key)

export const onceGetFirestoreProject = (projectType: number) =>
  firestore()
    .collection('projects')
    .where('type', '==', projectType)
    .where('publicAvailable', '==', 1)
    .orderBy('startDate', 'desc')

export const onceExperiment = () =>
  firestore()
    .collection('projects')
    .where('type', '==', 2)
    .where('publicAvailable', '==', 1)
    .orderBy('startDate', 'desc')

export const FindProject = (id: number) =>
  firestore()
    .collection('projects')
    .where('type', '==', 1)
    .where('id', '==', id)

export const FindProjectByName = (name: string, projectType: number) =>
  firestore()
    .collection('projects')
    .where('type', '==', projectType)
    .where('url_name', '==', name)

export const FindNextProject = (doc: any, projectType: number) =>
  firestore()
    .collection('projects')
    .where('publicAvailable', '==', 1)
    .where('type', '==', projectType)
    .orderBy('startDate', 'asc')
    .startAfter(doc)
    .limit(1)

export const FindPreviousProject = (doc: any, projectType: number) =>
  firestore()
    .collection('projects')
    .where('publicAvailable', '==', 1)
    .where('type', '==', projectType)
    .orderBy('startDate', 'desc')
    .startAfter(doc)
    .limit(1)

//Resources
export const GetResources = () => firestore().collection('resources')
export const onceGetFirestoreResources = (projectType: number) =>
  firestore()
    .collection('resources')
    .where('publicAvailable', '==', 1)
    .orderBy('pid', 'asc')

export const FindResource = (id: number) =>
  firestore()
    .collection('resources')
    .where('id', '==', id)
// .limit(1)

export const GetResourceByName = (name: string) =>
  firestore()
    .collection('resources')
    .where('publicAvailable', '==', 1)
    .where('url_name', '==', name)

export const FindNextResource = (doc: any) =>
  firestore()
    .collection('resources')
    .where('publicAvailable', '==', 1)
    .orderBy('id', 'asc')
    .startAfter(doc)
    .limit(1)

export const FindPreviousResource = (doc: any) =>
  firestore()
    .collection('resources')
    .where('publicAvailable', '==', 1)
    .orderBy('id', 'desc')
    .startAfter(doc)
    .limit(1)

export const onceGetFirestoreCompany = () => firestore().collection('company')
export const GetCompany = () => firestore().collection('company')
export const FindCompany = (id: number) =>
  firestore()
    .collection('company')
    .where('id', '==', id)
// .limit(1)

//Texts
export const GetTexts = () => firestore().collection('texts')
export const onceGetFirestoreTexts = () =>
  firestore()
    .collection('texts')
    .where('publicAvailable', '==', 1)
    .orderBy('posted', 'desc')

export const FindText = (id: number) =>
  firestore()
    .collection('texts')
    .where('id', '==', id)
// .limit(1)

export const GetTextByName = (name: string) =>
  firestore()
    .collection('texts')
    .where('publicAvailable', '==', 1)
    .where('url_name', '==', name)

export const FindNextText = (doc: any) =>
  firestore()
    .collection('texts')
    .where('publicAvailable', '==', 1)
    .orderBy('id', 'desc')
    .startAfter(doc)
    .limit(1)

export const FindPreviousText = (doc: any) =>
  firestore()
    .collection('texts')
    .where('publicAvailable', '==', 1)
    .orderBy('id', 'asc')
    .startAfter(doc)
    .limit(1)

//Authors
export const GetAuthors = () => firestore().collection('authors')
export const onceGetFirestoreAuthors = () =>
  firestore()
    .collection('authors')
    // .where('publicAvailable', '==', 1)
    .orderBy('id', 'asc')

export const FindAuthor = (id: number) =>
  firestore()
    .collection('authors')
    .where('id', '==', id)
// .limit(1)

export const GetAuthorByName = (name: string) =>
  firestore()
    .collection('authors')
    // .where('publicAvailable', '==', 1)
    .where('url_name', '==', name)

export const FindNextAuthor = (doc: any) =>
  firestore()
    .collection('authors')
    // .where('publicAvailable', '==', 1)
    .orderBy('id', 'asc')
    .startAfter(doc)
    .limit(1)

export const FindPreviousAuthor = (doc: any) =>
  firestore()
    .collection('authors')
    // .where('publicAvailable', '==', 1)
    .orderBy('id', 'desc')
    .startAfter(doc)
    .limit(1)

//Pages
export const GetPages = () => firestore().collection('pages')
export const onceGetFirestorePages = () =>
  firestore()
    .collection('pages')
    // .where('publicAvailable', '==', 1)
    .orderBy('id', 'asc')

export const FindPage = (id: number) =>
  firestore()
    .collection('pages')
    .where('id', '==', id)
// .limit(1)

export const GetPageByName = (name: string) =>
  firestore()
    .collection('pages')
    // .where('publicAvailable', '==', 1)
    .where('url_name', '==', name)

export const FindNextPage = (doc: any) =>
  firestore()
    .collection('pages')
    // .where('publicAvailable', '==', 1)
    .orderBy('id', 'asc')
    .startAfter(doc)
    .limit(1)

export const FindPreviousPage = (doc: any) =>
  firestore()
    .collection('pages')
    // .where('publicAvailable', '==', 1)
    .orderBy('id', 'desc')
    .startAfter(doc)
    .limit(1)
